import Vue from 'vue';
import Vuex from 'vuex';

import app from '@/stores/app';
import auth from '@/stores/auth';
import mission from '@/stores/mission';
import customer from '@/stores/customer';
import dlGroupConfig from "@/stores/dlgroup.config";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},

    modules: {
        app,
        auth,
        mission,
        customer,
        dlGroupConfig
    }
});